<template>
    <div>        
        <upload-image is="upload-image"
            input_id='formImages'
            :url="''"
            :max_files="5"
            name="files[]"
            :resize_enabled="true"
            :resize_max_width="640"
            :button_html="''"
            :button_class="''"
            :disable_upload="true"            
            @upload-image-attemp="uploadImageAttempt"
            @upload-image-success="uploadImageSuccess"
            @upload-image-failure="uploadImageFailure"
            @upload-image-loaded="uploadImageLoaded"
            @upload-image-submit="uploadImageSubmit"
            @upload-image-clicked="uploadImageClicked"
            @upload-image-removed="uploadImageRemoved"
        ></upload-image>
    </div>
</template>
<script>
export default {
    name: 'Uploader',
    data () {
      return {
      }
    },
    methods:{
        uploadImageAttempt(){
            console.log('intento');
        },
        uploadImageSuccess: function(result){
            console.log('ok');
            console.log(result);
        },
        uploadImageFailure: function(result){
            console.log('fail');
            console.log(result);        
        },
        uploadImageLoaded: function(image){
            console.log('load');
            console.log(image);   
            console.log(this.images);            
        },
        uploadImageSubmit: function(images){
            console.log('submit');
            console.log(images);
        },
        uploadImageClicked: function(image){
            console.log('click');
            console.log(image);   
            console.log(this.images);
        },
        uploadImageRemoved(){
            console.log('del');
        }
    },
    computed: {
        images: {
            get(){
                return this.$store.state.images;
            },
            set(value){
                this.$store.commit('saveImages',value);
            }
        }
    }
}
</script>
<style scoped>
    .vue_component__upload--image{
        background-color: lightblue;
    }
    .vue_component__upload--image > form{
        
    }
</style>